import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import router from "./router";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        session_id: null,
        agent_name:null,
        selected_agent:null,
        manual_verification: false,
        extractingText: false,
        extractedText: false,
        loginData: {
            Username: "false", PasswordToken: false, FaceToken: false, TrustedPartnerToken: false
        },
        loginState: {
            access_token: false,
        },
        expiry_message: "",
        reseller_logo: null,
        next_url_after_login:"/home",
        idSelfieRequired: false,
        step: 1,
        totalSteps: 0,
        language: "en",
        config: null,
        configPath: [],
    },
    mutations: {
        setManualVerification(currentStateObject,newState){
          currentStateObject.manual_verification = newState.manual_verification
        },
        setResellerLogo(currentStateObject, reseller_logo){
          currentStateObject.reseller_logo = reseller_logo
        },
        setSelectedAgent(currentStateObject,newState){
            currentStateObject.selected_agent = newState.selected_agent
        },
        setSessionStatus(currentStateObject, newState){
            currentStateObject.status = newState.status
        },
        setSessionID(currentStateObject, newState){
            currentStateObject.session_id = newState.session_id
            currentStateObject.agent_name = newState.agent_name
        },
        setExtractTextState(currentStateObject, newState) {
            currentStateObject.extractingText = newState.state;
            currentStateObject.extractedText = newState.data;
        },
        setLoginData(currentStateObject, newobj) {
            currentStateObject.loginData = newobj;
        },
        setIDSelfieRequired(currentStateObject, idSelfieRequired) {
            currentStateObject.idSelfieRequired = idSelfieRequired;
        },
        setLoginState(currentStateObject, newStateObject) {
            currentStateObject.loginState = newStateObject;

        },
        setTrustedPartnerState(currentStateObject, newStateObject) {
            currentStateObject.trustedPartner = newStateObject;
        },
        setExpiredMessage(currentMessage, newMessage) {
            currentMessage.expiry_message = newMessage;
        },
        setNextUrlAfterLogin(currentState,newValue){
            currentState.next_url_after_login = newValue
        },
        assignStep(currentState, path){
            currentState.step = currentState.configPath.indexOf(path) + 1
        },
        goToNextUrl(currentState){
            return currentState.configPath[currentState.step]
        },
        setLanguage(currentState, language){
            currentState.language = language
        },
        setConfig(currentState, {config, configPath}){
            currentState.config = config
            currentState.configPath = configPath
        }

    },
    actions:{

    },
    plugins: [createPersistedState()],
})
